<button mat-button (click)="onClick($event)" matTooltip="Navigation menu">
    <mat-icon>menu</mat-icon>
</button>